import { createContext } from 'react';

export const initialState = {
  goBack: () => {},
  lastUrl: '',
};

const CustomRouterContext = createContext(initialState);
CustomRouterContext.displayName = 'CustomRouterContext';

export default CustomRouterContext;
